import { onBeforeUnmount, onMounted } from 'vue';

const DOCUMENT_CLASS = 'customer-download-document';
let activeCustomerDownloadViews = 0;

function setDocumentClass(active: boolean): void {
  document.documentElement.classList.toggle(DOCUMENT_CLASS, active);
  document.body.classList.toggle(DOCUMENT_CLASS, active);
}

export function useCustomerDownloadDocumentLayout(): void {
  onMounted(() => {
    activeCustomerDownloadViews++;
    setDocumentClass(true);
  });

  onBeforeUnmount(() => {
    activeCustomerDownloadViews = Math.max(0, activeCustomerDownloadViews - 1);
    setDocumentClass(activeCustomerDownloadViews > 0);
  });
}
